import '../../external/jquery.ui.touch-punch.min';
import { sliderOptionFormat } from './search_slider_format';

export const searchYearSlider = {
    sliderName: '',
    fromElement: '',
    toElement: '',
    minimumValue: 1900,
    maximumValue: new Date().getFullYear() + 1,
    sliderOptionsCount: 0,
    sliderStepWidth: 0,
    sliderMaximum: 350, // keep this value multiply of length of list, i.e. this.sliderOptionsCount * 10
    list: [],

    generateList() {
        let yearList = [this.minimumValue, 1910, 1920, 1930, 1940, 1950, 1960, 1970, 1980, 1990, 2000];
        for (let i = 2001; i <= this.maximumValue; i++) {
            yearList.push(i);
        }

        this.list = yearList;
        this.sliderOptionsCount = yearList.length;
        this.sliderStepWidth = this.sliderMaximum / this.sliderOptionsCount;
    },
    init(optionsInput) {
        const options = optionsInput || {};
        this.sliderName = options.sliderName ? options.sliderName : $('#simple_search #yearSlider');
        this.fromElement = options.fromElement ? options.fromElement : $('#simple_search #yearFrom');
        this.toElement = options.toElement ? options.toElement : $('#simple_search #yearTo');
        this.generateList();

        this.sliderName.slider({
            animate: true,
            range: true,
            min: 0,
            max: this.sliderMaximum,
            create() {
                searchYearSlider.setSlider(searchYearSlider.fromElement.val(), searchYearSlider.toElement.val());
                searchYearSlider.sliderFormat();
            },
            slide(event, ui) {
                if (ui.handle.nextSibling) {
                    let minValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[0],
                        searchYearSlider.sliderOptionsCount,
                        searchYearSlider.sliderStepWidth
                    );
                    searchYearSlider.fromElement.val(searchYearSlider.list[minValIndex]);
                } else {
                    let maxValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[1],
                        searchYearSlider.sliderOptionsCount,
                        searchYearSlider.sliderStepWidth
                    );
                    searchYearSlider.toElement.val(searchYearSlider.list[maxValIndex]);
                }
                searchYearSlider.sliderFormat();
            },
            stop() {
                searchYearSlider.fromElement.trigger('change');
            },
        });
    },
    setSlider(fromValueInput, toValueInput) {
        let fromIndex = 0,
            toIndex = searchYearSlider.sliderMaximum;

        let fromValue = parseInt(fromValueInput, 10);
        let toValue = parseInt(toValueInput, 10);
        if (fromValue > 0) {
            fromValue = sliderOptionFormat.getClosestOption(searchYearSlider.list, fromValue);
            fromIndex = $.inArray(parseInt(fromValue, 10), searchYearSlider.list) * searchYearSlider.sliderStepWidth;
        }

        if (toValue > 0) {
            toValue = sliderOptionFormat.getClosestOption(searchYearSlider.list, toValue);
            toIndex = $.inArray(parseInt(toValue, 10), searchYearSlider.list) * searchYearSlider.sliderStepWidth;
        }

        searchYearSlider.sliderName.slider('values', [fromIndex, toIndex]);
    },
    sliderFormat() {
        sliderOptionFormat.setRangeSlider(
            searchYearSlider.fromElement,
            searchYearSlider.toElement,
            searchYearSlider.minimumValue,
            searchYearSlider.maximumValue,
            'yearRange',
            ''
        );
    },
};
